export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"
    >
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新 · 独家爆料
            </div>

            {/* H1 */}
            <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              51吃瓜黑料
              <span className="block text-primary-600 text-2xl md:text-3xl lg:text-4xl mt-1">
                热点爆料聚合平台
              </span>
            </h1>

            {/* Slogan */}
            <p className="font-heading text-lg md:text-xl text-accent-600 font-semibold mb-5">
              吃瓜不迷路，料从这里开始
            </p>

            {/* Intro */}
            <p className="text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 text-sm md:text-base mb-6">
              51吃瓜黑料汇聚全网最新吃瓜爆料与黑料曝光，覆盖娱乐圈、网红圈、社会热点等各领域网曝门事件内幕。
              每日实时更新独家猛料，让你第一时间掌握今日黑料动态。无论是热门话题还是冷门猛料，这里都是你最可靠的吃瓜前线阵地。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">365天不间断</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600">全领域覆盖</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">娱圈·网红·社会</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600">独家信源</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">一手猛料直击</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="whitespace-nowrap px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-flashlight-line mr-2"></i>查看最新爆料
              </a>
              <a
                href="#topics"
                onClick={(e) => handleScrollTo(e, '#topics')}
                className="whitespace-nowrap px-8 py-3.5 rounded-lg border-2 border-background-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-hashtag mr-2"></i>浏览热门话题
              </a>
            </div>
          </div>

          {/* Right: Main Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20editorial%20illustration%20of%20breaking%20news%20and%20hot%20gossip%20concept%2C%20warm%20red%20and%20amber%20color%20palette%20with%20newspaper%20texture%20elements%20and%20magnifying%20glass%20silhouette%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20modern%20minimalist%20composition%20on%20light%20cream%20background%2C%20editorial%20design%20aesthetic%2C%20high%20detail%20with%20subtle%20grain%20texture&width=960&height=720&seq=hero-visual-gossip&orientation=landscape"
                alt="51吃瓜黑料 - 热点爆料聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}